import { BATCH_CUSTOM_DATA_API_URL, batch } from '../config.env';
import { me } from '../helpers';
import axios from 'axios';

const headers = () => ({headers: {'X-Authorization': batch.REST_API_KEY}});

export const addBatchCustomData = (body, callback) => {
    axios.post(`${BATCH_CUSTOM_DATA_API_URL}/${me().ssoId}`, {
        "overwrite": false,
        "values": body
    },headers()).then(() => {
        if(callback) {
            callback();
        }
    })
}

export const removeBatchCustomData = data => {
    axios.post(`${BATCH_CUSTOM_DATA_API_URL}/${me().ssoId}`, {
        "overwrite": false,
        "values": {"ut.recipient": { "$remove": data}}
    }, headers());
}